module.exports = __webpack_public_path__ + "img/grid.9344c5f0.svg";